'use client';

import {
  Link as NavigationMenuLink,
  navigationMenuTriggerStyle,
} from '@mcdougald/ui/src';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
export function NavigationMenuInternalLink({ href, ...props }: any) {
  const pathname = usePathname();
  const isActive = href === pathname;

  return (
    <NavigationMenuLink asChild active={isActive}>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <Link href={href} className={navigationMenuTriggerStyle()} {...props} />
    </NavigationMenuLink>
  );
}
